import React, { memo, useEffect } from "react";
import { Card, CardBody, Row, Col, Button, UncontrolledAlert, ButtonToolbar, Spinner, Alert } from "reactstrap";
import { Field, reduxForm, clearFields, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MdArrowBack } from "react-icons/md";
import { Link } from "react-router-dom";
import { renderField } from "../../../../utils/renderfield";
import validate from "./validate";
import AccessControl from "../../../../shared/components/AccessControl";
import DomainDropDown from "../../../Domains/DomainDropDown";
import RolesSelect from "../../../Roles/RolesSelect";
import {
    resetRoles,
    /* addRolesToStore,
  removeRolesFromStore, */
    getRoles,
} from "../../../Roles/actions/roles.actions";
import { resetPostUser } from "../../actions/user.actions";
import { MdRefresh } from "react-icons/md";
import { accessControlFn } from "../../../../utils/accessControl";
import { permissionsConstants } from "../../../../constants/permission.constants";

const UserEditForm = memo((props) => {
    const { dispatch, handleSubmit, permissions, reset, pristine, invalid, submitting, userId, user, postuser, selectedDomainCode, change, fetchUser, userDetails } = props;

    const foundUser = user && user.response && user.response.content && user.response.content.length && !user.loading;

    const resetForm = () => {
        reset();
        accessControlFn(permissions, [permissionsConstants.ASSIGNUSER_ROLE], () => dispatch(resetRoles()));
    };

    useEffect(() => {
        //check the edit mode

        dispatch(resetPostUser());
        reset("user_edit_form");
        if (foundUser) {
            dispatch(change("first_name", user.response.content[0].firstName));
            dispatch(change("last_name", user.response.content[0].lastName));
            dispatch(change("email", user.response.content[0].email));
            dispatch(change("phone_number", user.response.content[0].mobileNo));
        }
        return () => {
            dispatch(resetPostUser());
        };
    }, [dispatch, foundUser]);

    const getRolesFromDomain = (selectedDomain) => {
        dispatch(clearFields("user_edit_form", true, true, "roles"));

        if (selectedDomain) {
            dispatch(getRoles(selectedDomain.code));
        } else {
            dispatch(resetRoles());
        }
    };
    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">
                            <Link to="/users" id="link-all-users">
                                <MdArrowBack size={20} /> Back to users
                            </Link>
                        </h5>
                    </div>
                    {userId && user && user.loading ? (
                        <div className="text-center">
                            <Spinner color="success" className="my-4" style={{ width: "6rem", height: "6rem" }} />
                            <h4 className="text-secondary">Fetching user details </h4>
                        </div>
                    ) : (
                        <div>
                            {!foundUser ? (
                                <section>
                                    <h4 className="text-danger">{user && user.error ? `Something went wrong. Could not fetch user with email (${userId})` : `User with email (${userId}) not found`}</h4>
                                    <Alert color="danger">
                                        Could not User Details
                                        {userDetails && userDetails.loading ? <Spinner className="float-right" size="sm" color="danger" /> : <MdRefresh onClick={fetchUser} className="float-right pointer" size={20} />}
                                    </Alert>
                                </section>
                            ) : (
                                <form className="form" onSubmit={handleSubmit}>
                                    {console.log("checking error message", postuser)}
                                    {postuser && postuser.error && postuser.error.errors && postuser.error.errors.length ? (
                                        <UncontrolledAlert color="danger">
                                            <h5 className="font-weight-bold">Please check the following fields for errors</h5>
                                            {postuser.error.errors.map((err) => (
                                                <p>
                                                    <strong>{err.fieldName}:</strong> {err.message}
                                                </p>
                                            ))}
                                        </UncontrolledAlert>
                                    ) : postuser && postuser.error && postuser.error.message ?  (
                                        <UncontrolledAlert color="danger">
                                            <p>
                                            <strong>{postuser.error.message}</strong>
                                            </p>
                                        </UncontrolledAlert>
                                    ) : null}
                                    <Row>
                                        <Col lg="4">
                                            <div className="form__form-group">
                                                <span className="form__form-group-label required">First name</span>
                                                <div className="form__form-group-field">
                                                    <Field id="first_name" name="first_name" component={renderField} type="text" placeholder="first name" />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4">
                                            <div className="form__form-group">
                                                <span className="form__form-group-label required">Last name</span>
                                                <div className="form__form-group-field">
                                                    <Field id="last_name" name="last_name" component={renderField} type="text" placeholder="last name" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="4">
                                            <div className="form__form-group">
                                                <span className={userId ? "form__form-group-label" : "form__form-group-label required"}>Email address</span>
                                                <div className="form__form-group-field">
                                                    <Field id="email" name="email" disabled={userId} component={renderField} type="email" placeholder="email address" />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4">
                                            <div className="form__form-group">
                                                <span className="form__form-group-label required">Phone number</span>
                                                {!userId ? <small style={{ color: "blue", fontSize: "9px" }}>(e.g 08022012222)</small> : null}
                                                <div className="form__form-group-field">
                                                    <Field id="phone_number" name="phone_number" component={renderField} type="tel" placeholder="phone number" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {!userId && (
                                        <Row>
                                            <AccessControl
                                                allowedPermissions={
                                                    [
                                                        // permissionsConstants.ASSIGNUSER_ROLE
                                                    ]
                                                }
                                                renderNoAccess={() => null}
                                            >
                                                <Col lg="4">
                                                    <DomainDropDown required id="domain" onChange={getRolesFromDomain} label="Add user to domain" />
                                                </Col>
                                            </AccessControl>

                                            <Col lg="4">
                                                <RolesSelect required id="role-select" label="Assign roles to user" selectedDomainCode={selectedDomainCode} />
                                            </Col>
                                        </Row>
                                    )}

                                    <ButtonToolbar className="form__button-toolbar">
                                        <Button type="button" id="reset-form" onClick={resetForm} disabled={pristine || submitting}>
                                            Cancel
                                        </Button>
                                        <Button color="primary" id="submit-btn" type="submit" disabled={submitting || invalid}>
                                            {postuser && postuser.loading ? (
                                                <span>
                                                    <Spinner size="sm" color="default" />{" "}
                                                </span>
                                            ) : null}
                                            Submit
                                        </Button>
                                    </ButtonToolbar>
                                </form>
                            )}
                        </div>
                    )}
                </CardBody>
            </Card>
        </Col>
    );
});

UserEditForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};

const selector = formValueSelector("user_edit_form");

export default reduxForm({
    form: "user_edit_form",
    validate,
    enableReinitialize: true,
})(
    connect((state) => {
        const domain = selector(state, "domains");
        return {
            postuser: state.postuser,
            selectedDomainCode: domain?.code || null,
            permissions: state.permissions && state.permissions.response,
            userDetails: state.viewuser,
        };
    })(UserEditForm)
);
